import { Component, Input, OnInit } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { select, Store } from "@ngrx/store";
import { LangChangeEvent, TranslateService } from "@ngx-translate/core";
import { Observable, takeUntil } from "rxjs";
import { BaseComponent } from "src/app/base.component";
import { Constants } from "src/app/shared/data/constants";
import { FeatureName } from "src/app/shared/enum/feature-name.enum";
import { PartnerStatus } from "src/app/shared/enum/partner-status";
import { PaymentFrequency } from "src/app/shared/enum/payment-frequency";
import { PricingMethod } from "src/app/shared/enum/pricing-method";
import { RouterBrandEnum } from "src/app/shared/enum/routerBrand";
import { BatchToggleFeatureElementDto } from "src/app/shared/models/features/batch-toggle-feature-element-dto.interface";
import { UserFeatureDto } from "src/app/shared/models/features/user-feature-dto.interface";
import { IberisActivities } from "src/app/shared/models/iberis/activities";
import { LocationPartnerInterface } from "src/app/shared/models/location-partners/locationPartner.interface";
import { BadgeService } from "src/app/shared/services/badge.service";
import { AppStateInterface } from "src/app/store/appState.interface";
import {
  getAllFeatures,
  invokeAllFeatures,
} from "src/app/store/features/features.actions";
import { allFeaturesSelector } from "src/app/store/features/features.selectors";
import { UtilFunctions } from "src/app/utils/utilFunctions";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-details-lp",
  templateUrl: "./details-lp.component.html",
})
export class DetailsLpComponent extends BaseComponent implements OnInit {
  @Input() locationPartner: LocationPartnerInterface;
  @Input() title: string;
  @Input() isFranchise: boolean | null = false;
  @Input() isFranchised: boolean | null = false;

  partnerStatus = PartnerStatus;
  pricingMethod = PricingMethod;
  paymentFrequencyToShow = PaymentFrequency;
  companyActivities: IberisActivities[];
  routerBrand = RouterBrandEnum;

  features: BatchToggleFeatureElementDto[] = [];
  features$: Observable<UserFeatureDto[] | null>;

  sessionTimeOut: { value: number, key: string }[]
  constructor(
    private store: Store<AppStateInterface>,
    private modalService: NgbModal,
    public badgeService: BadgeService,
    protected translate: TranslateService,
    private sanitizer: DomSanitizer
  ) {
    super(store);

    this.features$ = this.store
      .pipe(select(allFeaturesSelector))
      .pipe(takeUntil(this.ngDestroyed$));
  }

  ngOnInit(): void {
    this.store.dispatch(getAllFeatures({ features: null }));
    this.features$.subscribe((result) => {
      if (result) {
        const premiumFeature = result.filter(
          (feature) => feature.name === FeatureName.PREMIUM
        )?.[0];
        if (premiumFeature?.endDate) {
          this.locationPartner.premiumEndDate = premiumFeature.endDate;
        }
      } else {
        this.store.dispatch(
          invokeAllFeatures({ email: this.locationPartner.email })
        );
      }
    });

    if (this.translate.currentLang == "fr")
      this.companyActivities = Constants.IBERIS_ACTIVITIES_FR;
    else this.companyActivities = Constants.IBERIS_ACTIVITIES_EN;
    this.translate.onLangChange.subscribe(
      (langChangeEvent: LangChangeEvent) => {
        if (langChangeEvent.lang == "fr")
          this.companyActivities = Constants.IBERIS_ACTIVITIES_FR;
        else this.companyActivities = Constants.IBERIS_ACTIVITIES_EN;
      }
    );
    this.locationPartner = {
      ...this.locationPartner,
      companyActivity: this.companyActivities.find(
        (value) => this.locationPartner.companyActivity == value.hashed_id
      )?.title,
    };

    if (this.locationPartner.sessionTimeoutInMinutes) {
      const sessionTimeOutInMs = this.locationPartner.sessionTimeoutInMinutes * 60*1000;
      this.sessionTimeOut =
        UtilFunctions.getSessionDurationParts(sessionTimeOutInMs);
    }
  }
  closeModal() {
    this.modalService.dismissAll();
  }

  showlogo() {
    if (this.locationPartner?.logo) {
      return this.sanitizer.bypassSecurityTrustResourceUrl(
        environment.CDN_RELEAD + this.locationPartner.logo
      );
    } else return null;
  }
}
